import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faAngleDown, faSignOutAlt, faFile } from "@fortawesome/free-solid-svg-icons";
import { accountService } from "../services/accountService";
import logo from "../images/logoS.png";
import Avatar from "boring-avatars";
import "./NavMenu.css";

const NavMenu = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const user = accountService.userValue;

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const signOut = () => {
    accountService.logout();
    navigate("/login");
  };

  const linkStyle: React.CSSProperties = {
    color: "lightgrey",
    fontWeight: 600,
    textDecoration: "none",
    padding: "6px 10px",
    transition: "color 0.3s",
    listStyle: "none",
  };

  const linkHoverStyle: React.CSSProperties = {
    color: "#808080",
  };

  return (
    <header>
      <Navbar light className="mb-3 px-3 px-md-4" style={{ backgroundColor: "#FFFFFF" }}>
        <Container className="d-flex justify-content-between align-items-center">
          <NavbarBrand tag={Link} to="/">
            <img src={logo} alt="Checkardi" height="70" />
          </NavbarBrand>

          <Nav className="d-flex align-items-center" style={{ gap: "15px" }}>
            {user ? (
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  tag="div"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    userSelect: "none",
                    color: "lightgrey",
                  }}
                >
                  <Avatar
                    size={28}
                    name={user.userName}
                    variant="beam"
                    colors={["#F4C2C2", "#E8B4CB", "#D4A5A5", "#F0D0D0", "#F8E8E8"]}
                  />
                  <span style={{ fontSize: 16, marginRight: 5, marginLeft: 5, fontWeight: 600, color: "lightgrey" }}>
                    {user.userName}
                  </span>
                  <FontAwesomeIcon color="lightgrey" style={{ fontSize: 18 }} icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu end>
                <DropdownItem onClick={() => navigate(`/profile/${user.userName}`)}>
                  <FontAwesomeIcon color="lightgrey" style={{ fontSize: 18, marginRight: 8 }} icon={faUserCircle} />
                  Mój profil
                </DropdownItem>
                <DropdownItem onClick={() => navigate("/policyterm")}>
                  <FontAwesomeIcon color="lightgrey" style={{ fontSize: 18, marginRight: 8 }} icon={faFile} />
                  Polityka Prywatności
                </DropdownItem>
                <DropdownItem onClick={() => navigate("/regulations")}>
                  <FontAwesomeIcon color="lightgrey" style={{ fontSize: 18, marginRight: 8 }} icon={faFile} />
                  Regulamin
                </DropdownItem>
                <DropdownItem onClick={signOut}>
                  <FontAwesomeIcon color="lightgrey" style={{ fontSize: 18, marginRight: 8 }} icon={faSignOutAlt} />
                  Wyloguj
                </DropdownItem>
              </DropdownMenu>
              </Dropdown>
            ) : (
              <>
                <NavItem style={{ listStyle: "none" }}>
                  <NavLink
                    tag={Link}
                    to="/register"
                    style={linkStyle}
                    onMouseEnter={(e) => (e.currentTarget.style.color = linkHoverStyle.color!)}
                    onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color!)}
                  >
                    Zarejestruj
                  </NavLink>
                </NavItem>
                <NavItem style={{ listStyle: "none" }}>
                  <NavLink
                    tag={Link}
                    to="/login"
                    style={linkStyle}
                    onMouseEnter={(e) => (e.currentTarget.style.color = linkHoverStyle.color!)}
                    onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color!)}
                  >
                    Zaloguj
                  </NavLink>
                </NavItem>
              </>
            )}
          </Nav>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavMenu;
